import styles from '../style.module.css';

interface LoadingIndicatorProps {
    message?: string;
}

export function LoadingIndicator({
    message = 'Linda is typing...',
}: LoadingIndicatorProps) {
    return (
        <div
            className={styles.loadingIndicator}
            role="status"
            aria-live="polite"
            aria-label={message}
        >
            <div className={styles.loadingDots} aria-hidden="true">
                <div className={styles.loadingDot}></div>
                <div className={styles.loadingDot}></div>
                <div className={styles.loadingDot}></div>
            </div>
            {message}
        </div>
    );
}

interface ActionIndicatorProps {
    action: string;
}

export function ActionIndicator({action}: ActionIndicatorProps) {
    return (
        <div
            className={styles.actionIndicator}
            role="status"
            aria-live="polite"
            aria-label={action}
        >
            <div className={styles.actionDots} aria-hidden="true">
                <div className={styles.actionDot}></div>
                <div className={styles.actionDot}></div>
                <div className={styles.actionDot}></div>
            </div>
            {action}
        </div>
    );
}
